import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import {
  type CarrierLogisticsCredType,
  carrierLogistics,
} from '../standards.js'

export type totlCredType = CarrierLogisticsCredType
export const totlDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const totl: CarrierDef<totlCredType> = {
  name: 'Total Transportation and Distribution',
  scac: 'totl',
  ...carrierLogistics,
  engineLayers: ['documents', 'rating', 'profinder', 'pickup', 'tracking'],
  documentTypes: totlDocumentTypes,
}
